/*
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2015, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../ModeButton',
	'../../../api/DashboardAPI'
], function(BaseClass, DashboardAPI) {

	class ActionHandler extends BaseClass {
		onPress(context) {
			const dashboard = context.glassContext.appController.getCurrentContentView().getDashboardApi();
			dashboard.getFeature('DashboardState').setAuthoring(dashboard.getMode() === DashboardAPI.MODES.VIEW);
		}
	}

	return ActionHandler;
});
